import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Header from '../Header';
import CoachContainer from '../CoachContainer';
import ActivityGroupFilter from '../ActivityGroupFilter';
import CoachPanel from '../CoachPanel';

const Coachs = ({
  isPanelOpen,
  activeTab,
  currentCoach,
  onItemClick,
  onClosePanel,
  onChangeTab,
  params: { clientToken, clubId }
}) => (
  <Fragment>
    <Header clientToken={clientToken} clubId={clubId} />
    <ActivityGroupFilter />
    <CoachContainer onItemClick={onItemClick} clientToken={clientToken} clubId={clubId} />
    <CoachPanel
      coach={currentCoach}
      isOpen={isPanelOpen}
      onClose={onClosePanel}
      onChangeTab={onChangeTab}
      activeTab={activeTab}
    />
  </Fragment>
);

Coachs.propTypes = {
  currentCoach: PropTypes.shape({}),
  isPanelOpen: PropTypes.bool.isRequired,
  params: PropTypes.shape({
    clubId: PropTypes.string.isRequired
  }).isRequired,
  activeTab: PropTypes.string.isRequired,
  onChangeTab: PropTypes.func.isRequired,
  onItemClick: PropTypes.func.isRequired,
  onClosePanel: PropTypes.func.isRequired
};

Coachs.defaultProps = {
  currentCoach: undefined
};

export default Coachs;



// WEBPACK FOOTER //
// ./src/components/Coachs/Coachs.jsx